export default "__VITE_ASSET__F9I6yEGS__"